import * as Yup from "yup";
export const copyContactsFromListInitialValues = {
    list: "",
};
export const copyContactsFromListValidationSchema = Yup.object().shape({
    list: Yup.string().required("List is required"),
});
